import { DOCUMENTS_PACKAGE_TYPE } from "../../../data/static-data";
import Docs from "./docs/Docs";
import ShipmentBoxes from "./shipmentBox/ShipmentBoxes";
// import ShipmentItemsTable from "./ShipmentItemsTable";
import Upper from "./Upper";

const ShipmentItems = ({packageType}) => {
    
    return (
        <div>
            {/* <ShipmentItemsTable /> */}
            
            {
                packageType === DOCUMENTS_PACKAGE_TYPE 
                ? <Docs />
                : <>
                    <div className="mb-2">
                        <Upper />
                    </div>
                    <ShipmentBoxes />
                </>
            }
        </div>
    );
};

export default ShipmentItems;
